export var VELT_SDK_VERSION = '4.6.10';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.6.10': 'sha384-2OwSjccVDnJkLSKYOVgo0X8koTm/k5Cq7b2aRAihFBGCIDZOJEyvEiYFPhYkODdY',
};
